export default __webpack_public_path__ + "static/media/coming-soon-plant.15959f45.png";